import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "channel-information" }
const _hoisted_2 = { class: "row header q-mb-md" }
const _hoisted_3 = { class: "actions" }
const _hoisted_4 = { class: "row channels" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lock_closed_icon = _resolveComponent("lock-closed-icon")!
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_channel_product_card = _resolveComponent("channel-product-card")!
  const _component_entry_search = _resolveComponent("entry-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Channels", -1))
      ], true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "actions", {}, () => [
          (_ctx.locked)
            ? (_openBlock(), _createBlock(_component_lock_closed_icon, {
                key: 0,
                size: "24px"
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_q_btn, {
                  class: "q-ml-md add-channel",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.channelDialog.show = true)),
                  unelevated: "",
                  rounded: "",
                  outline: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_add_icon, { left: "" }),
                    _cache[4] || (_cache[4] = _createElementVNode("span", null, "Channel", -1))
                  ]),
                  _: 1
                }),
                (_ctx.editing)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      class: "btn secondary q-ml-md",
                      onClick: _ctx.cancel,
                      unelevated: "",
                      rounded: "",
                      flat: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_close_icon, { left: "" }),
                        _cache[5] || (_cache[5] = _createElementVNode("span", null, "Cancel", -1))
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ], 64)),
          (_ctx.editing)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 2,
                class: "btn primary q-ml-md",
                onClick: _ctx.save,
                unelevated: "",
                rounded: "",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_tick_icon, { left: "" }),
                  _cache[6] || (_cache[6] = _createElementVNode("span", null, "Save", -1))
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ], true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diffState.rhs, (catalogueProduct) => {
        return (_openBlock(), _createBlock(_component_channel_product_card, {
          key: catalogueProduct.sys?.id + '_' + _ctx.catalogueMapping[catalogueProduct.catalogue]?.sys?.id,
          editing: _ctx.editing,
          draft: catalogueProduct.sys?.draft,
          "channel-product": catalogueProduct,
          "product-price": catalogueProduct.price,
          channel: _ctx.catalogueMapping[catalogueProduct.catalogue],
          "pending-removal": catalogueProduct?.delete,
          "onUpdate:productPrice": ($event: any) => (_ctx.updateProductPrice(catalogueProduct, $event)),
          onRemove: _ctx.removeChannelProduct
        }, null, 8, ["editing", "draft", "channel-product", "product-price", "channel", "pending-removal", "onUpdate:productPrice", "onRemove"]))
      }), 128))
    ]),
    _createVNode(_component_entry_search, {
      show: _ctx.channelDialog.show,
      "content-type": "catalogue",
      payload: _ctx.channelDialog.collection,
      model: _ctx.channelDialog.model,
      onSelection: _cache[1] || (_cache[1] = s => { s.selection.forEach(_ctx.channelDialog.select); _ctx.addChannelDialogSelection(); _ctx.channelDialog.show = false}),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.channelDialog.show = false)),
      style: {"min-width":"320px","z-index":"9999"}
    }, null, 8, ["show", "payload", "model"])
  ]))
}